var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMegaboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 8H16C11.5817 8 8 11.5817 8 16V64C8 68.4183 11.5817 72 16 72H64C68.4183 72 72 68.4183 72 64V16C72 11.5817 68.4183 8 64 8ZM16 0C7.16344 0 0 7.16344 0 16V64C0 72.8366 7.16344 80 16 80H64C72.8366 80 80 72.8366 80 64V16C80 7.16344 72.8366 0 64 0H16Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 22H22V30H30V22ZM22 14C17.5817 14 14 17.5817 14 22V30C14 34.4183 17.5817 38 22 38H30C34.4183 38 38 34.4183 38 30V22C38 17.5817 34.4183 14 30 14H22Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 42C15.7909 42 14 43.7909 14 46C14 48.2091 15.7909 50 18 50H34C36.2091 50 38 48.2091 38 46C38 43.7909 36.2091 42 34 42H18Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58 50H50V58H58V50ZM50 42C45.5817 42 42 45.5817 42 50V58C42 62.4183 45.5817 66 50 66H58C62.4183 66 66 62.4183 66 58V50C66 45.5817 62.4183 42 58 42H50Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 14C43.7909 14 42 15.7909 42 18C42 20.2091 43.7909 22 46 22H62C64.2091 22 66 20.2091 66 18C66 15.7909 64.2091 14 62 14H46Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaboard);
export default __webpack_public_path__ + "static/media/megaboard.84ed806a132ef2d6f581436af9d99861.svg";
export { ForwardRef as ReactComponent };